export default __webpack_public_path__ + "static/media/cancel_icon.176e8521.svg";